import { ITokenResponse } from "../models/token";
import { BaseService } from "./base.service";

export class TokenService extends BaseService {
  public async fetchTokenResponse(
    accessToken: string | null
  ): Promise<ITokenResponse> {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    };

    const response = await fetch(
      `${this.getEndPoint()}/School/CreateToken`,
      requestOptions
    );
    if (response.ok) {
      const responseAsJson = await response.json();
      const token = responseAsJson.accessToken.token;
      if (token) {
        return responseAsJson;
      }
    }
    throw "Invalid token response";
  }

  public async refreshTokenResponse(userId: string): Promise<ITokenResponse> {
    const response = await fetch(
      `${this.getEndPoint()}/School/RefreshToken?userId=${userId}`
    );
    if (response.ok) {
      const responseAsJson = await response.json();
      const token = responseAsJson.accessToken.token;
      if (token) {
        return responseAsJson;
      }
    }
    throw "Invalid token response";
  }
}
